import { FC } from 'react';
import { CustomButton, If } from 'components';
import TransactionCardV2 from '../TransactionCardV2';
import { TransactionV2 } from '../../invoices.model';
import { ButtonType } from 'components/custom-button/CustomButton';
import { ChevronArrowRightIcon } from 'assets/icons';
import { StatusIndicator } from 'containers/invoices/constants';

interface InvoicePaymentsSectionProps {
  transactionsList: TransactionV2[];
  txnsTotalCount: number;
  onTxnClick: (id: string, status?: string) => void;
  onDisputeClick: (id: string) => void;
  onRefundClick: (id: string) => void;
  onToggleViewAll: () => void;
  onCollectPayment: () => void;
  onRecordPayment: () => void;
  invoiceStatusIndicator: string;
}

const InvoicePaymentsSection: FC<InvoicePaymentsSectionProps> = ({
  transactionsList,
  txnsTotalCount,
  onTxnClick,
  onDisputeClick,
  onToggleViewAll,
  onCollectPayment,
  onRecordPayment,
  invoiceStatusIndicator,
  onRefundClick
}) => {
  const TXNLIMIT = 5;

  return (
    <div className="rounded-md bg-white shadow-section">
      <div className="flex items-center justify-between px-4 py-3 text-17px font-bold text-headingGray">Payments</div>
      <div className="">
        <If condition={txnsTotalCount > 0}>
          <div className="px-5 pb-4">
            {transactionsList?.map((transaction, index) => (
              <TransactionCardV2
                key={`${transaction.transactionId}-${index}`}
                transaction={transaction}
                onTxnClick={onTxnClick}
                onDisputeClick={onDisputeClick}
                onRefundClick={onRefundClick}
                shouldCheckPermission={true}
              />
            ))}
          </div>
          <If condition={txnsTotalCount > TXNLIMIT}>
            <div
              className="flex cursor-pointer items-center justify-between border-y border-borderGray 
                px-4 py-3 text-sbase font-semibold leading-5 text-secondary"
              onClick={onToggleViewAll}
              role="button"
              tabIndex={0}
              aria-label="View all transactions">
              <span>View all transactions({txnsTotalCount})</span>
              <div className="flex shrink-0 items-center justify-center">
                <ChevronArrowRightIcon className="path-fill-current text-gray-1" />
              </div>
            </div>
          </If>
        </If>
        <If condition={txnsTotalCount > TXNLIMIT && invoiceStatusIndicator !== StatusIndicator.FULLY_PAID}>
          <div className="pt-4"></div>
        </If>
        <If condition={invoiceStatusIndicator !== StatusIndicator.FULLY_PAID}>
          <div className="flex flex-col gap-3 p-4 pt-0">
            <CustomButton
              id="collect-payment-button"
              className="h-10 w-full"
              childrenContainerStyles="text-17px"
              onClick={onCollectPayment}>
              Collect payment
            </CustomButton>
            <CustomButton
              id="record-payment-button"
              type={ButtonType.SECONDARY}
              className="h-10 w-full border border-gray-1"
              childrenContainerStyles="text-sbase font-semibold"
              onClick={onRecordPayment}>
              Record a payment
            </CustomButton>
          </div>
        </If>
      </div>
    </div>
  );
};

export default InvoicePaymentsSection;
